import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist()

export interface Page {
  id: string,
  name: string,
  type: string,
  route: string
}

const tabListState = atom<{
  current: number,
  pages: Page[]
}>({
  key: 'tabListState',
  default: {
    current: 0,
    pages: []
  },
  effects_UNSTABLE: [persistAtom]
});

export default tabListState;

